import FacebookPixel from 'react-facebook-pixel';

export class FacebookService {
  static initialized: boolean;

  constructor() {
    FacebookService.init();
  }

  static init(force = false) {
    if (!FacebookService.initialized || force) {
      const options = {
        autoConfig: true,
        debug: false,
      };
      FacebookPixel.init('981697515182465', undefined, options);
      FacebookService.initialized = true;
    }
  }

  public static trackSubscribe(price?: string) {
    FacebookPixel.track('Subscribe', {
      value: price || 'USD',
      currency: 'USD',
      predicted_ltv: price || 'USD',
    });
  }
}
